export const PHOTO = "photo";
export const VIDEO = "video";
